module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "outpfm1"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "x-2-chapter-title",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("Contents"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/preface"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/prologue"
    }
  }, [_vm._v("Prologue Bad Guys with Badges: A Vast Amount of Trouble")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/outP01"
    }
  }, [_vm._v("Chapter 1 Dirty Dave Rudabaugh: The Scum of the Earth")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/outP02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2 Hoodoo Brown and Company: The Thugs of Las Vegas")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/outP03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 Henry Newton Brown: It Was All for You")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/outP04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 John Larn: The Evil Genius of Fort Griffin")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/outP05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 Bob and Grat Dalton: Disaster at Coffeyville")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/outP06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 Wyatt Earp: Down by the Creek, Walkin’ on Water")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/outP07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 King Fisher and Ben Thompson: A Pair to Draw To")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/outP08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 The County Seat Wars: When the Good Guys Fought the Good Guys")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/outP09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 Henry Plummer: Into a World Unknown")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/outP10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 Joseph Alfred Slade: The Three Jacks")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/outP11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 Doc Middleton: The Adventures of Gold Tooth Charley")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/outP12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 Frank M. Canton: In the Paradise of the Desperado")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/biblio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c854456","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0